import { BackgroundColorTheme } from "./Background.types";
import { ChevronMain, ChevronMainCorail, ChevronBottom, ChevronBottomCorail, ChevronBackOffice, ChevronBottomBackOffice, } from "../../../assets/icons/static/BackgroundSVGs";
export function getBackgroundMainSvgFromColorTheme(colorTheme) {
    switch (colorTheme) {
        case BackgroundColorTheme.GREEN:
            return ChevronMain;
        case BackgroundColorTheme.CORAIL:
            return ChevronMainCorail;
        case BackgroundColorTheme.BO:
            return ChevronBackOffice;
        default:
            return ChevronMain;
    }
}
export function getBackgroundBottomSvgFromColorTheme(colorTheme) {
    switch (colorTheme) {
        case BackgroundColorTheme.GREEN:
            return ChevronBottom;
        case BackgroundColorTheme.CORAIL:
            return ChevronBottomCorail;
        case BackgroundColorTheme.BO:
            return ChevronBottomBackOffice;
        default:
            return ChevronBottom;
    }
}
//# sourceMappingURL=Background.helpers.js.map